import { Application, Controller } from "@hotwired/stimulus"
import "@hotwired/turbo-rails"

const application = Application.start()
application.debug = false
;(window as unknown as { Stimulus: Application }).Stimulus = application

const controllers = import.meta.glob<{ default: typeof Controller }>(
  "../controllers/*_controller.ts",
  { eager: true },
)

for (const path in controllers) {
  const name = path
    .replace("../controllers/", "")
    .replace("_controller.ts", "")
    .replace(/_/g, "-")
  application.register(name, controllers[path].default)
}
